import { GUARD_STORAGE_TTL_MS } from './constants';
import { ExamGuardState } from './types';

const STORAGE_KEY_PREFIX = 'exam-guard-summary';

function getStorageKey(certificationLogId: string) {
  return `${STORAGE_KEY_PREFIX}:${certificationLogId}`;
}

export function loadGuardState(
  certificationLogId: string,
): ExamGuardState | null {
  if (typeof window === 'undefined') return null;

  try {
    const rawState = window.localStorage.getItem(
      getStorageKey(certificationLogId),
    );

    if (!rawState) return null;

    const parsed = JSON.parse(rawState) as ExamGuardState;
    const expirationTime = parsed.validationExpiresAt
      ? new Date(parsed.validationExpiresAt).getTime()
      : 0;

    if (!expirationTime || expirationTime < Date.now()) {
      window.localStorage.removeItem(getStorageKey(certificationLogId));
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function saveGuardState(state: ExamGuardState) {
  if (typeof window === 'undefined') return;

  try {
    const nextState: ExamGuardState = {
      ...state,
      validationExpiresAt:
        state.validationExpiresAt ??
        new Date(Date.now() + GUARD_STORAGE_TTL_MS).toISOString(),
    };

    window.localStorage.setItem(
      getStorageKey(state.certificationLogId),
      JSON.stringify(nextState),
    );
  } catch {
    // noop
  }
}

export function clearGuardState(certificationLogId: string) {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.removeItem(getStorageKey(certificationLogId));
  } catch {
    // noop
  }
}
